<template>
  <div class="popup form-popup visible" id="extend-event-popup">
    <div class="popup-box">

      <p class="h2 title line">Extend LX EVENT</p>
      <form action="#" class="form">
        <div class="field">
          <label class="field-name">LX Terminal</label>
          <Select2 readonly :disabled="true" v-model="popupData.event.terminal_name" :options="terminals" :placeholder="popupData.event.terminal_name" name="select" class="select select-search" data-placeholder="Select LX Terminal" />
        </div>
        <div class="field-wrap">
          <div class="field start-date">
            <label class="field-name">Start date</label>
            <date-time-picker class="form-control datepicker" v-model="getStartDate" :options="dateOptions" placeholder="Start date" disabled="true"/>
          </div>
          <div class="field finish-date" :class="v$.finishDate.$error ? 'error-field' : ''">
            <label class="field-name">Finish date</label>
            <date-time-picker class="form-control datepicker" v-model="finishDate" :options="dateOptions" placeholder="Start date"  @update="checkDates"/>
            <span class="error-text" v-if="v$.finishDate.$error">You must fill Finish date.</span>
          </div>
        </div>
        <div class="field-wrap">
          <div class="field start-time">
            <label class="field-name">Start time</label>
            <date-time-picker class="form-control datepicker" v-model="startTime" :options="timeOptions" placeholder="Start time" disabled="true"/>
          </div>
          <div class="field finish-time" :class="v$.finishTime.$error ? 'error-field' : ''">
            <label class="field-name">Finish time</label>
            <date-time-picker class="form-control timepicker" v-model="finishTime" :options="timeOptions"
                              placeholder="Finish time" @update="checkDates"/>

            <span class="error-text" v-if="v$.finishTime.$error">You must fill Finish time.</span>
          </div>
        </div>
        <div class="field location">
          <div class="field-name-wrap">
            <label class="field-name">Location</label>
            <a href="" class="locate" @click.prevent="locateMeClick">Locate me</a>
          </div><Select2 :disabled="true" readonly v-model="popupData.event.location" :options="locations" :placeholder="popupData.event.location" name="select" class="select select-search" data-placeholder="Select LX Terminal" />

        </div>
        <div class="error-field" v-if="generalMessage">
          <span class="error-text">{{generalMessage}}</span>
        </div>
        <div class="form-btn-box">
          <button class="btn success no-bg small js-close-popup" @click.prevent="closePopup">
            <icon-base width="20" height="21" viewBox="0 0 20 21">
              <icon-deny/>
            </icon-base>
            <span>Cancel</span>
          </button>
          <button type="button" class="btn success small js-open-popup" data-popup="request-registered-popup" @click.prevent="updateEventClick">
            <icon-base width="20" height="21" viewBox="0 0 26 27">
              <icon-success/>
            </icon-base>
            <span>Extend</span>
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>

import {mapMutations, mapActions, mapState} from "vuex"
import Select2 from './MySelect2';
import DateTimePicker from "../common/DateTimePicker"
import { useVuelidate } from "@vuelidate/core";
import { required } from "@vuelidate/validators";
import IconBase from "../common/IconBase";
import IconDeny from "../common/icons/IconDeny";
import IconSuccess from "../common/icons/IconSuccess";

export default {
    name: 'add-event',

    setup () {
        return { v$: useVuelidate() }
    },

    validations() {
        return {
            startTime: {required},
            finishDate: {required},
            finishTime: {required},
        }
    },

    data () {
        return {
            startDate: null,
            startTime: null,
            finishTime: null,
            finishDate: null,
            timeOptions: {
                datepicker: false,
                format: 'H:i',
            },
            dateOptions: {
                timepicker: false,
                format: 'Y-m-d',
            },
            terminal_name: '',
            generalMessage: ''
        }
    },
    components: {IconSuccess, IconDeny, IconBase, Select2, DateTimePicker},

    computed: {
        getStartDate() {
            return this.popupData.event.start_time.split(' ')[0]
        },
        getFinishDate() {
            return this.popupData.event.finish_time.split(' ')[0]
        },
        ...mapState({
            popupData: state => state.popupData,
        }),
    },

    methods: {
        getTime(date) {
            let parts = date.split(' ');
            if (parts[1]) {
                let parts2 = parts[1].split(':')
                return parts2[0] + ':' + parts2[1];
            }
        },
        getDate(date) {
            let parts = date.split(' ');
            return parts[0] ? parts[0] : '';
        },
        ...mapMutations([
            'switchPopup',
        ]),
        ...mapActions('events', [
            'updateEvent',
            'loadEvents'
        ]),
        closePopup() {
            this.switchPopup(false);
        },
        checkDates() {
            this.generalMessage = '';
            if (new Date(this.startDate + ' ' + this.startTime) >= new Date(this.finishDate + ' ' + this.finishTime)) {
                this.generalMessage = 'Event start date and time cannot be later than the end';
                return false;
            }

            return true;
        },
        updateEventClick() {
            this.v$.$touch();
            if (!this.v$.$invalid) {
                if (!this.checkDates()) return false;

                let event = Object.assign({}, this.popupData.event);
                event.finish_time = this.finishDate + ' ' + this.finishTime + ':00';

                this.updateEvent(event).then(() => {
                    this.loadEvents();
                    this.switchPopup(false);
                }).catch(() => {
                })
            }
        }

    },
    mounted() {
        this.finishTime = this.getTime(this.popupData.event.finish_time);
        this.finishDate = this.getDate(this.popupData.event.finish_time);
        this.startTime = this.getTime(this.popupData.event.start_time);
        this.startDate = this.getDate(this.popupData.event.start_time);
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .select2-container {
    width: 500px !important;
  }
  .field.select {
    margin: 0 0 5px;
  }

  .field:not(.error-field) .form-control {
    margin-bottom: 15px;
  }
  .popup .error-field::before {
    bottom: 22px;
  }

  .popup .error-field::after{
    bottom: 33px;
  }

  .popup .start-time:not(.error-field)::before, .popup .finish-time:not(.error-field)::before, .popup .start-date:not(.error-field)::before, .popup .finish-date:not(.error-field)::before {
    bottom: 15px;
  }

  .popup .start-date:not(.error-field)::after, .popup .finish-date:not(.error-field)::after, .popup .start-time:not(.error-field)::after, .popup .finish-time:not(.error-field)::after{
    bottom: 25px;
  }


</style>
